import React from 'react';
import NavLink from '../NavLink';

import './styles.scss';


const Footer = () => (
  <footer className='site-footer' styleName='site-footer'>

    <div className='navbar navbar-light bg-faded'>

      <ul className='navbar-nav'>

        <NavLink to='/about/'>About</NavLink>

        <NavLink to='/privacy/'>Privacy Policy</NavLink>

        <NavLink to='/contact/'>Contact</NavLink>

      </ul>

      <p className='navbar-text' styleName='copyright'>
        Places data powered by&nbsp;
        <a href='https://www.factual.com' target='_blank' rel='noopener noreferrer'>Factual Inc</a>.
        Copyright &copy;{ new Date().getFullYear() } Chargerville. All rights reserved.
      </p>

    </div>

  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/Footer/index.jsx